import { Inject } from 'inversify-props'
import { EstoqueServiceAdapter } from './adapter'
import { EstoqueProjection, FormDeItemDeEstoque } from '@/models'

export class SaveEstoqueUseCase {
	@Inject('EstoqueServiceAdapter')
	private estoqueService!: EstoqueServiceAdapter

	create = async (idDeposito: string, estoque: FormDeItemDeEstoque) =>
		await this.estoqueService.create(idDeposito, estoque)

	add = async (idEstoque: string, qtde: number) =>
		await this.estoqueService.add(idEstoque, qtde)

	retirar = async (idEstoque: string, qtde: number) =>
		await this.estoqueService.retirar(idEstoque, qtde)

	empenhar = async (idEstoque: string, qtde: number) =>
		await this.estoqueService.empenhar(idEstoque, qtde)

	reaver = async (idEstoque: string, qtde: number) =>
		await this.estoqueService.reaver(idEstoque, qtde)

	alterarEstoqueMinimo = async (idEstoque: string, qtdeEstoqueMinimo: EstoqueProjection) => {
		await this.estoqueService.alterarEstoqueMinimo(idEstoque, qtdeEstoqueMinimo)
		
	}
}
